import './system/yup-init';
import './system/sentry-init';

import { StrictMode } from 'react';

import * as ReactDOM from 'react-dom/client';

import App from './app';

import './index.css';
import './i18n';
import './dayjs';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
